export const staticNodeKeys = ["loveitem_finder","store_finder","strap_finder","watch_finder"]